/* Donder scroll-cues — verbetert affordance op horizontaal-scrollbare carousels.
   - Bounce-nudge bij eerste viewport-entry (1× per row per page-load)
   - Toggle .is-at-end class wanneer carousel volledig naar rechts is gescrolled
     (CSS verbergt dan de chevron-fade) */
(function () {
  if (window.__donderScrollCuesInit) return;
  window.__donderScrollCuesInit = true;

  var SELECTOR = '.scrollable-grid--desktop, .scrollable-grid--small, .collection-row--scroll, .collection-row--group';

  var nudged = new WeakSet();
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function isOverflowing(el) {
    return el.scrollWidth - el.clientWidth > 4;
  }

  function checkEnd(el) {
    if (!isOverflowing(el)) return;
    var atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 4;
    el.classList.toggle('is-at-end', atEnd);
  }

  function nudge(el) {
    if (nudged.has(el) || prefersReducedMotion || !isOverflowing(el)) return;
    nudged.add(el);
    var nudgeDist = Math.min(32, Math.max(20, el.clientWidth * 0.05));
    /* Wait a tick so layout is stable */
    setTimeout(function () {
      el.scrollTo({ left: nudgeDist, behavior: 'smooth' });
      setTimeout(function () {
        el.scrollTo({ left: 0, behavior: 'smooth' });
      }, 700);
    }, 250);
  }

  function attach(el) {
    if (el.__donderScrollAttached) return;
    el.__donderScrollAttached = true;
    el.addEventListener('scroll', function () {
      checkEnd(el);
    }, { passive: true });
    /* Initial state check */
    checkEnd(el);
  }

  function init() {
    var els = document.querySelectorAll(SELECTOR);
    if (!els.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          nudge(entry.target);
        }
      });
    }, { threshold: 0.4 });

    els.forEach(function (el) {
      attach(el);
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-init bij section-render (Shopify theme editor) en bij dynamische updates */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
})();
